import { render, staticRenderFns } from "./BusinessProgramDeleteConfirmationModal.vue?vue&type=template&id=6133dcb7"
import script from "./BusinessProgramDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./BusinessProgramDeleteConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports